import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { RouterModule, Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../environments/environment";
import "rxjs/add/operator/do";
import "rxjs/add/operator/shareReplay";
import { BucketService } from "../EmaSystemsComponentsV1_0_0/bucket/bucket";
import { map, switchMap } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable()
export class AuthService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private bucket: BucketService
  ) {}
  //Este es el que se debe modificar
  login(username: string, password: string) {
    sessionStorage.setItem("access_token_admin", "AIONSYSTEMSADMINTEMPURL");
    const params = new HttpParams({
      fromObject: {
        user_email: username,
        user_password: password,
        language_id: "1",
      },
    });
    return this.httpClient
      .post(environment.api.login_LF_V1, params, {
        headers: new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .do((authResult: any) => {
        console.log("---> " + username);
        localStorage.setItem("company_id", authResult.data[0].company_id + "");
        localStorage.setItem("session_active_admin", "active");
        //sessionStorage.setItem('access_token_admin', authResult.data.access_token);
        //sessionStorage.setItem('refresh_token_admin', authResult.data.refresh_token);
        sessionStorage.setItem("access_token_admin", authResult.token);
        sessionStorage.setItem("refresh_token_admin", authResult.refresh_token);
        //localStorage.setItem('user_id_profile_admin', authResult.data.user_data.user_id);
        localStorage.setItem(
          "user_id_profile_admin",
          authResult.data[0].users_id
        );
        localStorage.setItem("user_name_profile_admin", username);
        localStorage.setItem("user_role_admin", authResult.data[0].role_id);
        //localStorage.setItem('branch_office_name_admin', authResult.data.branch_office.name);
        //localStorage.setItem('company_name_admin', authResult.data.branch_office.company_name);
      })
      .shareReplay();
  }

  refreshToken(access_token: string, refresh_token: string) {
    // console.log("refreshToken session.....");
    //session_active == 'null' ? "nulo" : 0
    if (
      localStorage.getItem("session_active_admin") == "inactive" ||
      localStorage.getItem("session_active_admin") == "null"
    ) {
      this.logout();
      // console.log("Session cerrada en otra pestaña");
      return;
    } else if (localStorage.getItem("session_active_admin") == "active") {
      //console.log("Session abierta...");
    }
    const params = new HttpParams({
      fromObject: {
        token: access_token,
        refresh_token: refresh_token,
      },
    });
    return this.httpClient
      .post(environment.api.refreshTokenAuto, params, {
        headers: new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
      })
      .do((authResult: any) => {
        sessionStorage.setItem(
          "access_token_admin",
          authResult.data.access_token
        );
        sessionStorage.setItem(
          "refresh_token_admin",
          authResult.data.refresh_token
        );
      })
      .shareReplay();
  }

  logout() {
    //console.log("user id:: " + localStorage.getItem('customer'));
    // remove user from local storage to log user out
    const params = new HttpParams({
      fromObject: {
        user_id: localStorage.getItem("user_id_profile_admin"),
        token: sessionStorage.getItem("access_token_admin"),
      },
    });

    return this.httpClient
      .post(
        environment.api.logout_v1 +
          localStorage.getItem("user_id_profile_admin"),
        params,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
            token: sessionStorage.getItem("access_token_admin"),
          }),
        }
      )
      .do((data) => {
        console.log("Navigate to...");

        sessionStorage.removeItem("access_token_admin");
        sessionStorage.removeItem("refresh_token_admin");
        localStorage.removeItem("user_admin");
        localStorage.removeItem("branch_office_name_admin");
        localStorage.removeItem("menu_admin");
        localStorage.removeItem("submenu_admin");
        localStorage.removeItem("company1_id_admin");
        localStorage.removeItem("company_branch_id_admin");
        //Se elimina menu
        localStorage.removeItem("titleMenu_admin");
        this.router.navigate([
          "/login/" + localStorage.getItem("comp_login_token"),
        ]);
        sessionStorage.clear();
        localStorage.clear();
      });
  }
  refreshTokenObselete(access_token: string, refresh_token: string) {
    const params = new HttpParams({
      fromObject: {
        token: access_token,
        refresh_token: refresh_token,
      },
    });
    return this.httpClient
      .post(
        "http://adec-authorization.us-east-2.elasticbeanstalk.com/v1/ema-system/both/refresh-token",
        params,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
          }),
        }
      )
      .do((authResult: any) => {
        sessionStorage.setItem("access_token", authResult.data.access_token);
        sessionStorage.setItem("refresh_token", authResult.data.refresh_token);
      })
      .shareReplay();
  }

  logoutObsolete() {
    // remove user from local storage to log user out
    //localStorage.getItem('user_id')
    //console.log(localStorage.getItem('user_id'));
    const params = new HttpParams({
      fromObject: {
        user_id: "1",
      },
    });
    return this.httpClient
      .post(
        "http://adec-authorization.us-east-2.elasticbeanstalk.com/v1/ema-system/both/logout",
        params,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/x-www-form-urlencoded",
          }),
        }
      )
      .do((data) => {
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("refresh_token");
        localStorage.removeItem("customer");
        localStorage.removeItem("customerBranch");
        localStorage.removeItem("user");
        localStorage.removeItem("branch_office_name");
        localStorage.removeItem("menu");
        localStorage.removeItem("submenu");
        localStorage.removeItem("esEmpleado");
        localStorage.removeItem("company1_id");
        localStorage.removeItem("company_branch_id");
        //Se elimina menu
        localStorage.removeItem("titleMenu");
        this.router.navigate(["/login"]);
      });
  }

  obtenerMenu() {
    let user_id = localStorage.getItem("user_id_profile_admin");
    let rol = localStorage.getItem("user_role_admin");
    let pagetype_id = 1;
    localStorage.setItem("language-id", 1 + ""); //set language in spanish = 1
    return this.httpClient
      .get(environment.api.menu_LF_V1, {
        params: {
          role_id: rol,
          user_id: user_id,
          pagetype_id: pagetype_id + "",
        },
      })
      .do((menuResp: any) => {
        if (menuResp.status == 200) {
          if (menuResp.body != null) {
            let accessURL = [];
            let defaultURL = "";
            //filtrar sidebar

            let menuTemp = menuResp.body.filter((item) => {
              item.submenu = item.submenu.filter((subitem) => {
                accessURL.push(subitem.path); //si se llena
                if (subitem.is_default_page == 1) {
                  localStorage.setItem("menu_admin", item.menu_id);
                  localStorage.setItem("submenu_admin", subitem.menu_id);
                  defaultURL = subitem.path; //si se llena
                }
                return subitem.is_in_menu == 1;
              });
              return item.is_in_menu == 1;
            });
            //mapear sidebar
            menuTemp.map((item) => {
              item.title = item.module;
              item.class = item.class_;
              item.submenu.map((subitem) => {
                subitem.class = subitem.class_;
                subitem.submenu = [];
                // console.log(subitem);
                return subitem;
              });
              return item;
            });
            let menu = {
              data: menuTemp,
              accessURL: accessURL,
              defaultURL: defaultURL,
            };
            console.log("-------------MENU", menu);
            sessionStorage.setItem("menu_admin", JSON.stringify(menu));
            localStorage.setItem("menu-info", JSON.stringify(menu.data));
          } else {
            console.log("No encontro menu");
          }
        }
        //console.log("Todo el menu:", menuResp.body);
      });
  }

  getCompanyByToken(company_token) {
    console.log("company_token", company_token);
    console.log("url", environment.api.companySecurity);
    return this.httpClient
      .get(environment.api.companySecurity, {
        params: {
          company_token: company_token.toString(),
        },
        headers: new HttpHeaders({
          token:
            sessionStorage.getItem("access_token_admin") ||
            "AIONSYSTEMSADMINTEMPURL",
        }),
      })
      .map((data) => data);
  }
  refreshTokenV1(access_token: string): Observable<any> {
    return this.httpClient
      .post(
        environment.api.refreshTokenAuto,
        {
          access_token,
        },
        { responseType: "text" }
      ) // 👈 importante: porque backend responde con string
      .pipe(
        // guardar el token directamente
        switchMap((token: string) => {
          sessionStorage.setItem("access_token_admin", token);
          return new Observable((observer) => {
            observer.next(token);
            observer.complete();
          });
        })
      );
  }

  validateToken(): Observable<any> {
    return this.httpClient.post(
      environment.api.validateToken,
      {},
      {
        headers: {
          token: sessionStorage.getItem("access_token_admin") || "",
        },
      }
    );
  }
}
